import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Card } from '@uhg-abyss/web/ui/Card';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import React from 'react';

/**
 * NotFound
 *
 * This component is used to display a not found message.
 *
 * @param button
 * @param icon
 * @param message
 * @param title
 * @returns {Element}
 * @constructor
 */
export function NotFound({ button = null, icon = '', message = '', title = '' }) {
  return (
    <ErrorHandler location="src/entities/Criteria/ui/components/NotFound/NotFound.jsx">
      <Layout.Group
        alignLayout="center"
        css={{
          padding: `${Number(themeConfiguration?.theme?.space?.lg?.replace('px', '')) * 4}px 0px`,
        }}
      >
        <Card
          css={{
            borderStyle: 'dashed',
            boxShadow: 'none',
          }}
        >
          <Layout.Stack
            css={{
              padding: `${Number(themeConfiguration?.theme?.space?.lg?.replace('px', '')) * 2}px ${
                Number(themeConfiguration?.theme?.space?.xl?.replace('px', '')) * 4
              }px`,
            }}
            space={0}
          >
            <IconSymbol color="var(--abyss-colors-gray5)" icon={icon} size="48px" variant="outlined" />
            <div>
              <strong>{title}</strong>
            </div>
            <div>{message}</div>
            <div style={{ marginTop: 'var(--abyss-space-lg)' }}>{button}</div>
          </Layout.Stack>
        </Card>
      </Layout.Group>
    </ErrorHandler>
  );
}
